export default __webpack_public_path__ + "static/chunks/ui-assets/pattern-open-white/1e7192c42068898ca28e2e170f476ede.png";